import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <div className="w-6 h-6 bg-auris-teal rounded-md flex items-center justify-center">
              <span className="text-white text-xs font-bold">A</span>
            </div>
            <span className="text-sm text-gray-600">
              © 2024 TinniTrack by Auris. All rights reserved.
            </span>
          </div>
          
          <div className="flex space-x-6 text-sm text-gray-600">
            <button className="hover:text-auris-teal transition-colors">
              Privacy Policy
            </button>
            <button className="hover:text-auris-teal transition-colors">
              Terms of Service
            </button>
            <button className="hover:text-auris-teal transition-colors">
              Contact
            </button>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-gray-200 text-center">
          <p className="text-xs text-gray-500">
            This tool is for informational purposes only and is not a substitute for professional medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
